import { AlertTriangle, X } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PAYRUN } from "@/constants/testIds";

const NOTICE_ID = "sick_ph_v1";

export default function SickPHBanner() {
    const { user, setUser } = useAuth();
    const dismissed = user?.dismissed_notices?.includes(NOTICE_ID);
    if (!user || dismissed) return null;

    const dismiss = async () => {
        try {
            const { data } = await api.post("/auth/dismiss-notice", { notice_id: NOTICE_ID });
            setUser?.(data);
        } catch (_) {
            // fall back: optimistic client-only dismissal
            setUser?.({ ...user, dismissed_notices: [...(user.dismissed_notices || []), NOTICE_ID] });
        }
    };

    return (
        <div
            data-testid={PAYRUN.banner}
            className="flex items-start gap-3 px-4 py-3 border-l-2 mb-4 rounded-[3px]"
            style={{
                background: "var(--kp-warn-bg)",
                borderLeftColor: "var(--kp-warn)",
                color: "#5A3600",
            }}
        >
            <AlertTriangle size={16} className="mt-0.5 shrink-0" style={{ color: "var(--kp-warn)" }} />
            <div className="flex-1 text-[13px] leading-relaxed">
                <strong className="font-semibold">Public holiday hours are split into two buckets — worked vs taken.</strong>{" "}
                PH <em>worked</em> pays at ×2.0 (double time). PH <em>taken</em> and sick pay at ordinary rate.
                <br />
                <strong className="font-semibold">Leave entitlement is unconfirmed.</strong>{" "}
                Whether PNG staff accrue annual + sick leave has not been confirmed in writing — the
                director and the bookkeeper disagree. The accrual engine keeps running to the rates
                supplied 4 September 2026 pending a written answer.
            </div>
            <button
                data-testid={PAYRUN.bannerDismiss}
                onClick={dismiss}
                className="text-[11px] font-display font-semibold uppercase tracking-[0.12em] px-2.5 py-1 border rounded-[3px] hover:bg-white"
                style={{ borderColor: "var(--kp-warn)", color: "#5A3600" }}
            >
                Got it
            </button>
        </div>
    );
}
